import { Box, BoxProps, Loader, ModalDialog, Spacer, Text, TextNew, ColorOptions } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { Header } from '../../components/Header'
import { List } from '../../components/List'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { InstrumentForm } from './InstrumentForm'

const PackageToInstrument = () => {
  const [isLoading, setLoading] = useState(true)
  const [isModal, setModal] = useState(false)
  const [data, setData] = useState({})

  const navigation = useNavigation()
  const { getAll, package2InsList, fetchPackageNames, packageNames, accessConfig } = useStores((store) => ({
    getAll: store.packageToInstrument.getAll,
    package2InsList: store.packageToInstrument.instruments,
    length: store.packageToInstrument.instruments.length,
    fetchPackageNames: store.package.fetchPackageNames,
    pnlength: store.package.packageNames.length,
    packageNames: store.package.getPackageNames(),
    accessConfig: store.user.getAccessConfig(['routing', 'package_instrument_mapping']),
  }))

  const [lazyGetAll, lazyGetAllHandler] = useLazyApiData(getAll)
  // const [lazyGetPackageNames, lazyGetPackageNamesHandler] = useLazyApiData(getPackageNames)

  const keyExtractor = (item: any): string => {
    return item.id
  }

  useFocusEffect(
    useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        lazyGetAll()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]),
  )

  useEffect(() => {
    if (lazyGetAllHandler.state === 'fulfilled' || lazyGetAllHandler.state === 'rejected') {
      setLoading(false)
    }
  }, [lazyGetAllHandler])

  useEffect(() => {
    fetchPackageNames()
  }, [fetchPackageNames])

  const headTitles = [
    { id: 'ID' },
    { packageName: 'Package Name' },
    { instrument: 'Instrument' },
    { fileName: 'Filename' },
    { isGenerated: 'Is Generated' },
  ]

  const onPress = (item: any) => {
    setData(item)
    setModal(true)
  }

  const getMappingList = () => {
    if (lazyGetAllHandler.state === 'pending') {
      return <Loader />
    } else if (package2InsList.length < 1) {
      return <TextNew>{'No Package To Instrument Mapping Found'}</TextNew>
    }
    return (
      <Box>
        <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={5}
          sizeConfig={[1, 2, 2, 2, 2]}
          data={package2InsList}
          onPress={onPress}
        />
      </Box>
    )
  }

  const onAdd = () => {
    setData({})
    setModal(true)
  }

  const onSuccess = () => {
    setModal(false)
  }

  return (
    <Box>
      <Header
        left={{ title: 'Package To Instrument Mapping', subtitle: ['Routing', 'Package To Instrument Mapping'] }}
        right={{
          secondOnPress: isAccessible(accessConfig, 'add') && onAdd,
          secondTitle: 'Add Mapping',
        }}
      />
      <Spacer direction="vertical" size={24} />
      <Box {...styles.listContainer}>
        <Text fontSize={16} fontFamily={'jiotype-bold'} color={'#214796' as ColorOptions}>
          Mapping List
        </Text>
        <Spacer direction="vertical" size={16} />
        {isAccessible(accessConfig, 'fetch') && getMappingList()}
      </Box>
      <ModalDialog
        children={
          <InstrumentForm
            data={data}
            packageNames={packageNames}
            onSuccess={onSuccess}
            isDeletable={isAccessible(accessConfig, 'delete')}
            isEditable={isAccessible(accessConfig, 'update')}
            onClose={() => setModal(false)}
          />
        }
        show={isModal}
        type={'Right'}
      />
    </Box>
  )
}

export default PackageToInstrument

const styles = {
  container: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
  } as BoxProps,
  innerContainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
  listContainer: {
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
  } as BoxProps,
}
